module.exports = __webpack_public_path__ + "img/power.f9fe9846.svg";